import { boPhanSearchColumns, nhomColumns, QUERY_KEYS } from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { FormActions, FormState } from '../../hooks';
import { BoPhan, NhomPhi } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormState;
    actions: FormActions;
  };
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode, formState: { state, actions } }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Mã phí</Label>
          <div className='w-[240px]'>
            <FormField type='text' name='ma_phi' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên phí</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_phi' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên khác</Label>
          <div className='w-full'>
            <FormField type='text' name='ten_khac' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Nhóm phí 1</Label>
          <SearchField<NhomPhi>
            name='nh_phi1'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=PHI1`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm phí 1'
            columnDisplay='ma_nhom'
            displayRelatedField='ten_phan_nhom'
            className='w-[210px]'
            onRowSelection={actions.setNhomPhi1}
            value={state.nhomPhi1?.ma_nhom || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Nhóm phí 2</Label>
          <SearchField<NhomPhi>
            name='nh_phi2'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=PHI2`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm phí 2'
            columnDisplay='ma_nhom'
            displayRelatedField='ten_phan_nhom'
            className='w-[210px]'
            onRowSelection={actions.setNhomPhi2}
            value={state.nhomPhi2?.ma_nhom || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Nhóm phí 3</Label>
          <SearchField<NhomPhi>
            name='nh_phi3'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=PHI3`}
            searchColumns={nhomColumns}
            dialogTitle='Danh mục nhóm phí 3'
            columnDisplay='ma_nhom'
            displayRelatedField='ten_phan_nhom'
            className='w-[210px]'
            onRowSelection={actions.setNhomPhi3}
            value={state.nhomPhi3?.ma_nhom || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Bộ phận</Label>
          <SearchField<BoPhan>
            name='ma_bp'
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
            searchColumns={boPhanSearchColumns}
            dialogTitle='Danh mục bộ phận'
            columnDisplay='ma_bp'
            displayRelatedField='ten_bp'
            className='w-[210px]'
            onRowSelection={actions.setBoPhan}
            value={state.boPhan?.ma_bp || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='trang_thai'
              disabled={formMode === 'view'}
              options={[
                { label: '1. Còn sử dụng', value: 1 },
                { label: '0. Không sử dụng', value: 0 }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
